exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../../images/welcome.svg"));
// Module
exports.push([module.id, ".welcome-page {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-size: 64%;\n  background-repeat: no-repeat;\n}\n.welcome-image {\n  background-image: url(" + ___CSS_LOADER_URL___0___ + ");\n}\n", ""]);
